import { CobliAxios } from './CobliAxios';
import type HttpStatusCode from './HttpStatusCode';
import type { Configuration, IRequest } from './Types';
import axios, { type CancelTokenSource } from 'axios';

import { Environment } from '@cobliteam/react-environments';

import { SessionManager } from '../account/session/SessionManager';

const env = Environment.getInstance().getEnvironment();

class Requester {
  private axiosInstance: CobliAxios;

  private cancelToken: CancelTokenSource | null = null;

  private sessionManager: SessionManager;

  constructor(
    configuration: Configuration,
    sessionManager: SessionManager = new SessionManager({
      host: env.herbieApiHost,
    })
  ) {
    this.axiosInstance = new CobliAxios(configuration);
    this.sessionManager = sessionManager;
  }

  public getCancelToken = () => this.cancelToken;

  public request = (requestData: IRequest, nonReportableToSentryErrors?: HttpStatusCode[]) => {
    // NOTE: as this token is being shared on a same instance, using the same instance for
    // multiple requests will only allow to cancel the last one.
    this.cancelToken = axios.CancelToken.source();

    return this._request(requestData, this.cancelToken, nonReportableToSentryErrors);
  };

  public externalRequest = (requestData: IRequest, nonReportableToSentryErrors?: HttpStatusCode[]) => {
    // NOTE: as this token is being shared on a same instance, using the same instance for
    // multiple requests will only allow to cancel the last one.
    this.cancelToken = axios.CancelToken.source();
    return this._request(requestData, this.cancelToken, nonReportableToSentryErrors, true);
  };

  public requestWithCancelToken = (requestData: IRequest, cancelToken: CancelTokenSource) => {
    return this._request(requestData, cancelToken);
  };

  private _request = (requestData: IRequest, cancelToken: CancelTokenSource, nonReportableToSentryErrors: HttpStatusCode[] = [], external = false) => {
    return this.sessionManager.maybeRenewAccessToken().then(() => this.axiosInstance.request(requestData, cancelToken, nonReportableToSentryErrors, external));
  };
}

export default Requester;
